module.exports = __webpack_public_path__ + "media/data.9e28e499.mp4";